import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { ApiClient } from '../api'
import type { EventCateringBody } from '../types'

// Catering (Feature 3). Per-event list keyed on eventId; the cross-event
// report feeds the global catering PDF in Reports.

export function useCatering(eventId: number) {
  return useQuery({
    queryKey: ['catering', eventId],
    queryFn: () => ApiClient.eventCatering(eventId),
    enabled: Number.isFinite(eventId) && eventId > 0
  })
}

export function useCreateCatering(eventId: number) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: EventCateringBody) => ApiClient.createCatering(eventId, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['catering', eventId] })
  })
}

export function usePatchCatering(eventId: number) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: EventCateringBody }) => ApiClient.patchCatering(eventId, id, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['catering', eventId] })
  })
}

export function useDeleteCatering(eventId: number) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => ApiClient.deleteCatering(eventId, id).then(() => id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['catering', eventId] })
  })
}

export function useCateringReport() {
  return useQuery({
    queryKey: ['catering-report'],
    queryFn: () => ApiClient.reportsCatering(),
    staleTime: 60_000
  })
}
